/*
 * Copyright (c) Worldline 2023.
 */

export const FileExtension = {
    jpg: 'jpg',
    jpeg: 'jpeg',
    pjpeg: 'pjpeg',
    png: 'png',
    gif: 'gif',
    pdf: 'pdf',
    tiff: 'tiff'
}
